import rules from "../../Data/Rules"
import functions from "../../Data/Functions"
import Verification from "../Steps/Verification"
import store from "../../veux/store"

let Associations, Events, step1
// Load Models
const LoadModel = async (Passed) => {
    let result = {
        Portal: '2023 Facilitator Led Training Program',
        MainColor: "#f5924c",
        Logo: require(`../../assets/BQLogo2.png`),
        Title: `<h2>2023 Facilitator Led Training Program Registration Form</h2>`,
        Description: ``,
        Model: {},
        steps: [
            // Step 1
            step1,
            // Step 2
            {
                stepno: 2,
                title: 'Facilitator led training program',
                valid: true,
                information: ``,
                Model: {},
                Schema: {
                    firstname: {
                        type: 'text',
                        label: 'First Name',
                        outlined: true,
                        dense: true,
                        rules: [rules.requiredMsg('Firstname is Required')],
                        class: 'mx-1 px-1',
                        OUG: { Contacts: { Field: "firstname" } },
                        onInput: (ev, portal) => {
                            ev.data.firstname = functions.capitalizeFirstLetter(ev.data.firstname);
                        }
                    },
                    surname: {
                        type: 'text',
                        label: 'Last Name',
                        outlined: true,
                        dense: true,
                        rules: [rules.requiredMsg('Surname is Required')],
                        class: 'mx-1 px-1',
                        OUG: { Contacts: { Field: "surname" } },
                        onInput: (ev, portal) => {
                            ev.data.surname = functions.capitalizeFirstLetter(ev.data.surname);
                        }
                    },
                    DOB: {
                        type: 'text',
                        ext: 'date',
                        locale: 'en',
                        label: `Date of Birth (${store.getters.getdateFormat})`,
                        outlined: true,
                        dense: true,
                        mask: store.getters.getdateMask,
                        rules: [rules.requiredMsg('Date of Birth is Required')],
                        class: 'mx-1 px-1',
                        OUG: { Contacts: { Field: "date_of_birth" } }
                    },
                    gender: {
                        type: "select",
                        label: "Gender",
                        outlined: true,
                        dense: true,
                        rules: [rules.requiredMsg('Gender is Required')],
                        class: 'mx-1 px-1',
                        items: rules.Gender,
                        value: '',
                        OUG: { Contacts: { Field: "gender" } }
                    },
                    email: {
                        type: 'email',
                        label: 'Email Address',
                        outlined: true,
                        dense: true,
                        // col: 12,
                        rules: [rules.validEmail, rules.requiredMsg('Email is Required')],
                        class: 'mx-1 px-1',
                        prependInnerIcon: 'alternate_email',
                        toCtrl: ({ data }) => { return data.email },
                        OUG: { Contact_Details: { Type: 3, Action: "Unique" } }
                    },
                    mobile: {
                        type: 'tel',
                        label: 'Mobile Number',
                        outlined: true,
                        dense: true,
                        rules: [rules.requiredMsg('Mobile Number is Required')],
                        mask: "####-###-###",
                        class: 'mx-1 px-1',
                        prependInnerIcon: 'phone',
                        toCtrl: ({ data }) => { return data.mobile },
                        OUG: { Contact_Details: { Type: 8, Action: "Unique" } }
                    },
                    Association: {
                        type: "select",
                        label: "Select your Association",
                        outlined: true,
                        dense: true,
                        col: 12,
                        rules: [rules.requiredMsg('Association is Required')],
                        class: 'mx-1 px-1',
                        items: Associations,
                        returnObject: true,
                        itemText: 'Detail',
                        Role: null,
                        onInput: (ev, portal) => {
                            ev.data.Team = {
                                Detail: 'Non Profit Training',
                                Code_id: 3721,
                                Association: ev.data.Association.Code_id
                            }
                        },
                    },
                    Team: {
                        "type": "text",
                        "label": "Which Club are you registering for?",
                        outlined: true,
                        dense: true,
                        hidden: true,
                        rules: [],
                        class: 'mx-1 px-1',
                        Role: 13,
                        OUG: { Contact_Roles: true, Type: "Teams" }
                    },
                    event: {
                        type: "select",
                        label: "Select Event",
                        outlined: true,
                        multiple: true,
                        dense: true,
                        col: 12,
                        rules: [rules.requiredMsg('Event is Required')],
                        class: 'mx-1 px-1',
                        items: Events,
                        returnObject: true,
                        itemText: `title`,
                        OUG: { Bookings: true }
                    }
                },
                PreStep: (thisStep, portal) => {
                    let { Model, Schema } = thisStep

                    let currentUser = store.getters.currentUser,
                        loggedIn = store.getters.loggedIn

                    Schema.firstname.disabled = true
                    Schema.surname.disabled = true
                    Schema.DOB.disabled = true

                    currentUser.EmailDetail ? portal.Model.email = currentUser.EmailDetail : null
                    currentUser.PhoneDetail ? portal.Model.mobile = currentUser.PhoneDetail : null

                },
            },
            // Step 3
            {
                stepno: 3,
                title: 'Finalisation',
                valid: true,
                information: `Thank you for your submitted registration for the 2023 Facilitator led training program.</br>`,
                Model: {},
                Schema: {}
            }
        ]
    }
    // Load the Model with step elements
    result.steps.forEach(element => {
        element.Model = result.Model
    });
    return result
}

export default {
    init: async (Parameters) => {
        step1 = await Verification.LoadSchema(1)
        Associations = await functions.GetCodeBy({ Type: "Associations", Organisation: 292 }, true);
        Events = await functions.GetEvents({ Entity_id: 3721 }, true)
        let result = await LoadModel(Parameters)
        return result;
    },
}